import type { ElectricalProjectInspectionKind } from '@connected/elektra-sdk/validators/electrical-project';

import { Button } from '@connected/ui/components/button';
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@connected/ui/components/dropdown-menu';
import { ChevronDown } from 'lucide-react';

const KIND_LABELS: Record<string, string> = {
    Scope8: 'Scope 8',
    Scope10: 'Scope 10',
    Scope12: 'Scope 12',
    Nen1010: 'NEN 1010',
    Nen3140: 'NEN 3140',
};

export type ReportKindDropdownProps = {
    enabledKinds: Set<ElectricalProjectInspectionKind>;
    onToggle: (kind: ElectricalProjectInspectionKind) => void;
    allKinds: ElectricalProjectInspectionKind[];
    disabled: boolean;
};

export function ReportKindDropdown({ enabledKinds, onToggle, allKinds, disabled }: ReportKindDropdownProps) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button size="icon" disabled={disabled}>
                    <ChevronDown />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuLabel>Rapporten</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {allKinds.map(kind => (
                    <DropdownMenuCheckboxItem
                        key={kind}
                        checked={enabledKinds.has(kind)}
                        onCheckedChange={() => onToggle(kind)}
                    >
                        {KIND_LABELS[kind] ?? kind}
                    </DropdownMenuCheckboxItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
